import { Component, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { operationActionEnum, stepperEnum } from '../../../common/enum/bulkExportEnum';
import { Art57Section } from '../../../ui/Art57Section/Art57Section';
import { SectionService } from '../../../service/section-service/section-service';
import { PageChangeType } from '../../../common/enum/PageChangeTypeEnum';
import { LoggerService } from '../../../service/logger-service/logger.service';
import { environment } from '../../../../../environments/environment';
import { BulkService } from '../../../service/bulk-service/bulk.service';
import { BulkOperationSourceEnum } from '../../../ui/Node/MedicinalProductsNode/BulkOperationSourceEnum';
import { BulkSection } from '../../../ui/Art57Section/BulkSection';
import { BulkUpdateSection } from '../../../ui/Art57Section/BulkUpdateSection';
import { BulkupdateEventsService } from '../../../service/bulk-update-event-service/bulk-update-event.service';
import { ConfirmationService } from 'primeng/api';
import { ErrorControlUtil } from '../../../ui/ErrorControlUtil';
import { ErrorType } from '../../../ui/Node/ErrorType';
import { RepeaterService } from '../../../service/repeater-service/repeater.service';
import { BulkUpdateActionTypeComponent } from '../../../type/bulk-update-action-type/bulk-update-action-type.component';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';


@Component({
  selector: 'app-bulk-update-toolbox',
  templateUrl: './bulk-update-toolbox.component.html',
  styleUrl: './bulk-update-toolbox.component.scss'
})
export class BulkUpdateToolboxComponent {
  @Output() buttonAction = new EventEmitter();
  disableCount: boolean = false;
  @ViewChild('bulk_update_action') bulk_update_action!: BulkUpdateActionTypeComponent;
  constructor(private injector: Injector, private repeaterService: RepeaterService) {
  }

  onButtonAction(buttonAction: String, parameter: string = '') {
    switch (buttonAction) {
      case 'count':
        this.count();
        break;
      case 'request':
        this.request();
        break;
      case 'refresh':
        this.refresh();
        break;
      case 'firstPage':
        this.changeRequestsPage(PageChangeType.First);
        break;
      case 'previousPage':
        this.changeRequestsPage(PageChangeType.Previous);
        break;
      case 'nextPage':
        this.changeRequestsPage(PageChangeType.Next);
        break;
      case 'cancelRequest':
        this.changeRequestsPage(PageChangeType.Cancel);
        break;
      case 'archiveRequest':
        this.changeRequestsPage(PageChangeType.Archive);
        break;
      case 'add':
        this.addActions();
        break;
      case 'remove':
        this.removeActions();
        break;
      case 'openRequest':
        const bulkSection = this.injector.get(Art57Section).bulkupdate as BulkSection;
        const actions = bulkSection.criteriaModel.actionset;
        if (this.isActionsFilled(actions)) {
          this.injector.get(ConfirmationService).confirm({
            header: 'Please confirm you wish to open the selected request.',
            message: '<span>All current unsaved data from the Actions Set tab will be lost</span>',
            icon: 'pi pi-question-circle',
            acceptLabel: 'Yes, open',
            rejectLabel: 'Cancel',
            accept: () => {
              this.onLoad();
            }
          });
        } else {
          this.onLoad();
        }

        break;
      case "saveActions":
        this.saveActions();
        break;
      case "reloadActions":
        this.reloadActions();
        break;
      case "update":
        this.updateBulk();
        break;
      default:
        const data = { action: buttonAction, param: parameter };
        this.buttonAction.emit(data);
    }
  };

  onLoad() {
    this.injector.get(Art57Section).bulkupdate.actionSetLoaded = false;
    this.changeRequestsPage(PageChangeType.Open);
    // move to actions tab
    this.injector.get(Art57Section).bulkupdate.selectedStep = stepperEnum.thirdStep;
    this.injector.get(SectionService).notifyUpdatedBulkModel(BulkOperationSourceEnum.UPDATE);
  }

  count() {
    this.injector.get(Art57Section).showSuccessTooltipMessage('Requesting Counting', '', environment.successElapsedTime);
    this.disableCount = true;
    this.injector.get(BulkService).count(this.injector.get(Art57Section).bulkupdate.criteriaModel).subscribe({
      next: (data) => {
        this.injector.get(Art57Section).bulkupdate.criteriaModel.filterCount = data;
        this.injector.get(Art57Section).showSuccessTooltipMessage('Counting Completed', '', environment.successElapsedTime);
        this.injector.get(SectionService).notifyUpdatedBulkModel(BulkOperationSourceEnum.UPDATE);
        const countValue = this.getCountValue();
        if (countValue == undefined || countValue == '(0)') {
          this.injector.get(Art57Section).showWarningTooltipMessage('No results found, please review filters section', '', environment.successElapsedTime);
        }
        this.disableCount = false;
      },
      error: () => {
        this.disableCount = false;
      }
    }
    );
  }

  getCountLabel() {
    if (!this.disableCount) {
      return 'Count ' + this.getCountValue();
    }

    return 'Counting';
  }

  getCountValue(): string {
    const countValue: String = this.injector.get(Art57Section).bulkupdate.criteriaModel.filterCount;
    return countValue != null || countValue != undefined ? `(${countValue})` : '';
  }

  request() {
    const bulkSection = this.injector.get(Art57Section).bulkupdate as BulkSection;
    const bulkService = this.injector.get(BulkService);
    const sectionService = this.injector.get(SectionService);

    this.injector.get(Art57Section).showSuccessTooltipMessage('Requesting Export');
    bulkSection.selectedStep = stepperEnum.secondStep;
    sectionService.notifyUpdatedBulkModel(BulkOperationSourceEnum.UPDATE);
    this.injector.get(Art57Section).showSuccessTooltipMessage('Waiting to be Queued');

    bulkService.request(bulkSection.criteriaModel).subscribe({
      next: (data) => {
        const count = data;
        this.injector.get(Art57Section).bulkupdate.criteriaModel.filterCount = count;
        if (count > 0) {
          bulkService.notifyRefresh(BulkOperationSourceEnum.UPDATE);
          this.injector.get(Art57Section).showSuccessTooltipMessage('Export successfully requested');
        } else {
          this.injector.get(Art57Section).showWarningTooltipMessage('Request not submitted as the result set is empty');
        }
      },
      error: (err) => {
        this.injector.get(Art57Section).showErrorTooltipMessage('Requesting Export failed');
        this.injector.get(LoggerService).err(err);
      }
    });
  }

  refresh() {
    this.injector.get(BulkService).notifyRefresh(BulkOperationSourceEnum.UPDATE);
  }

  isFirstStep() {
    return this.injector.get(Art57Section).bulkupdate.isStepperFirstStep();
  }

  isSecondStep() {
    return this.injector.get(Art57Section).bulkupdate.isStepperSecondStep();
  }

  isThirdStep() {
    return this.injector.get(Art57Section).bulkupdate.isStepperThirdStep();
  }

  changeRequestsPage(pageChangeType: PageChangeType): void {
    const bulkExportService = this.injector.get(BulkService);
    bulkExportService.notifyPageChange(pageChangeType, BulkOperationSourceEnum.UPDATE);
  }

  // Label for Paginator for the requests
  getCurrentPageLabel(): string {
    const section = this.injector.get(Art57Section).bulkupdate as BulkSection;
    const pagination = section?.cachedRequests?.paginationControl;

    if (!pagination || pagination.currentPage == null || isNaN(pagination.currentPage)) {
      return '1'; // fallback (page index 0 → page 1)
    }

    const currentIndex = pagination.currentPage; // 0‑based
    return (currentIndex + 1).toString();
  }

  // True - you are in the first page in the Paginator; otherwise false
  isFirstPage(): boolean {
    const section = this.injector.get(Art57Section).bulkupdate as BulkSection;
    const pagination = section?.cachedRequests?.paginationControl;

    if (!pagination || pagination.currentPage == null || isNaN(pagination.currentPage)) {
      // Treat "unknown" as first page to stay safe
      return true;
    }

    return pagination.isFirstPage();
  }

  isCancelable(): boolean {
    const section = this.injector.get(Art57Section).bulkupdate as BulkSection;
    const selectedItem = section?.selectedItem;
    return selectedItem && selectedItem.isCancelable;
  }

  isArchivable(): boolean {
    const section = this.injector.get(Art57Section).bulkupdate as BulkSection;
    const selectedItem = section?.selectedItem;
    return selectedItem && selectedItem.isArchivable;
  }

  isOpen(): boolean {
    const section = this.injector.get(Art57Section).bulkupdate as BulkUpdateSection;
    const selectedItem = section?.selectedItem;
    return selectedItem && selectedItem.isOpen;
  }

  hasActions(): boolean {
    const section = this.injector.get(Art57Section).bulkupdate as BulkSection;
    const selectedItem = section?.selectedItem;
    return selectedItem && selectedItem.hasActions;
  }

  // True - if there is next page; False there is not next page, you are already in the next page
  hasNextPage(): boolean {
    const section = this.injector.get(Art57Section).bulkupdate as BulkSection;
    const cache = section?.cachedRequests;

    // If undefined, be conservative and assume there might be a next page.
    return cache?.hasNextPage ?? true;
  }

  saveActions() {
    const bulkSection = this.injector.get(Art57Section).bulkupdate as BulkSection;
    const bulkService = this.injector.get(BulkService);
    const item = bulkSection.selectedItem;
    const actions = bulkSection.criteriaModel.actionset;
    if (this.isActionsFilled(actions)) {
      bulkService.operationActions(item, operationActionEnum.save, actions).subscribe({
        next: (data) => {
          this.injector.get(Art57Section).showSuccessTooltipMessage('Actions save successfully completed');
        },
        error: (err) => {
          this.injector.get(Art57Section).showErrorTooltipMessage('Actions save failed');
          this.injector.get(LoggerService).err(err);
        }
      })
    } else {
      this.injector.get(Art57Section).showErrorTooltipMessage('No actions defined');
    }
  }

  addActions() {
    this.repeaterService.triggerAdd();
  }

   removeActions() {
    this.repeaterService.triggerRemove();
  }

  reloadActions() {
    this.injector.get(Art57Section).bulkupdate.actionSetLoaded = false;
    this.injector.get(BulkupdateEventsService).triggerLoadActions();
  }

  updateBulk() {
    const bulkSection = this.injector.get(Art57Section).bulkupdate as BulkSection;
    const bulkService = this.injector.get(BulkService);
    const item = bulkSection.selectedItem;
    const actions = bulkSection.criteriaModel.actionset;

    const hasErrors: boolean = this.hasErrors();
    if (this.isActionsFilled(actions) && !hasErrors) {
      bulkService.operationActions(item, operationActionEnum.update, actions).subscribe({
        next: (data) => {
          this.injector.get(Art57Section).showSuccessTooltipMessage('Bulk update message successfully created.  Please go to "Bulk Update" section in "WEB Trader" to retrieve it.');
        },
        error: (err) => {
          this.injector.get(Art57Section).showErrorTooltipMessage('Bulk update failed');
          this.injector.get(LoggerService).err(err);
        }
      })
    } else {
      if (!hasErrors) {
        this.injector.get(Art57Section).showErrorTooltipMessage('No actions defined');
      } else {
        this.injector.get(Art57Section).showErrorTooltipMessage('There are errors that needs to be fixed');
      }
    }

  }

  private isActionsFilled(actions: any) {
    return actions && actions.action.some((e: any) => e.operation && e.operation.length > 0);
  }

  private hasErrors(): boolean {
    const bulkUPdateSection = this.injector.get(Art57Section).bulkupdate as BulkUpdateSection;
    const hasErrors: boolean = bulkUPdateSection.errors.filter((err: any) => err.errorType != ErrorType.errorInactive).length > 0;
    
    return hasErrors;
  }

}
